<template>
  <div></div>
</template>

<script>
import { getCampaignService } from '@/services/campaignService'

export default {
  name: "campaignRedirect",
  data() {
    return {
      urls: {
        'play-store': 'https://play.google.com/store/apps/details?id=com.vocale.vocale'
      }
    }
  },
  mounted() {
    (async () => {
      const payload = {
        campaign_id: this.$route.params.campaignId,
        referrer: document.referrer
      }

      await getCampaignService().sendData(payload)

      let target = this.urls[this.$route.params.targetName]
      location.href = target
    })()
  }
}
</script>

<style>

</style>